import { LocationResponse } from 'containers/ServicesPage/types';

export const isWithingRange = (
  locationLat: number,
  locationLng: number,
  referenceLat: number,
  referenceLng: number,
  range: number,
): boolean =>
  Math.abs(locationLat - referenceLat) <= range &&
  Math.abs(locationLng - referenceLng) <= range;

export const filterLocationByRaisonSociale = (
  locations: LocationResponse[],
  filtre: string,
): LocationResponse[] => {
  return locations.filter((location: any) =>
    location.raison_sociale.toLowerCase().includes(filtre.toLowerCase()),
  );
};
